import React from "react";
import { getIn } from "formik";

export default class CheckBox extends React.Component<any, any> {
  onBlur = (args: any) => {
    const { field, onBlur } = this.props;
    field.onBlur(args);

    if (onBlur) onBlur(args);
  };

  onChange = (args: any) => {
    const { field, onChange } = this.props;
    field.onChange(args);

    if (onChange) onChange(args);
  };

  render() {
    const { baseValue, className, field, form, onBlur, ...props } = this.props;
    const { errors, touched } = form;
    const error = getIn(touched, field.name) && getIn(errors, field.name);

    let newClassName = className;
    if (error) newClassName += " red-border";
    if (baseValue && baseValue !== field.value)
      newClassName += " not-presumed-value";

    return (
      <>
        <input
          id={field.name}
          className={newClassName}
          {...field}
          checked={field.value}
          {...props}
          type="checkbox"
          onBlur={this.onBlur}
          onChange={this.onChange}
        />
        {error && <span className="text-danger">{error}</span>}
      </>
    );
  }
}
